import axios from 'axios';
import React from "react";
import GsuiteAuth from '../components/Auth/GsuiteAuth';
import { Progress } from "reactstrap";
import FormatCode from '../common/FormatCode';
import Format from './Format';
import { GetMessage } from '../variables/message';
import GoogleDrive from  "../common/GoogleDrive"

function openRequestModal(result, modalOn=true){
    const {status, statusText, data} = result.response||result
    if (status===200){
        if (data.Code>=800){
            setProgress(0)
            modalOn&& this.props.alertModal.current.showErrorModal({message:`[${data.Code}]`+data.Message});
        } else {
            // modalOn&& this.props.alertModal.current.showErrorModal({title:'成功', message:'成功しました。'});
        }
    }else {
        setProgress(0)
        if (status==401){
            GsuiteAuth.logout()
        }
        modalOn&& this.props.alertModal.current.showErrorModal({message:`[${(status||result.name)}]`+(statusText||result.message)});
    }
}

function setLoading(value) {
    this.setState({
        loading: value
    })
}

function setProgress(value, progressMessage, underbarMessage){
    this.setState({
        progress: value,
        progressMessage,
        underbarMessage
    })
}

export default class Request extends React.Component{
    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            progress: 0,
            progressMessage: "処理中",
        }
        openRequestModal = openRequestModal.bind(this)
        setLoading = setLoading.bind(this)
        setProgress = setProgress.bind(this)
    }

    componentDidUpdate (prevProps) {
//        console.log("componentDidUpdate",this.props,this.state);
    }

    static post(url, data, success_callback, error_callback, finally_callback, with_auth_header=true, modal=true, loading_flag=true) {
        let headers = {};
        if(with_auth_header) {
            headers.Authorization = 'Token ' + GsuiteAuth.get('token');
        }
        loading_flag && setLoading(true)
        axios.post(url, data ? data : {}, {headers: headers}).then(res => {
            setLoading(false)
            // do thomething
            if(res.data.Data){
                let tmp = res.data
                let result = tmp
                result.data = tmp.Data
                result.status = tmp.Code
                success_callback && success_callback(result);
            }else{
                success_callback && success_callback(res);
            }
            openRequestModal(res, modal)
        }).catch(error => {
            setLoading(false)
            // do thomething
            console.log(error);
            error_callback && error_callback(error);
            openRequestModal(error, modal)
        }).finally(() => {
            // setLoading(false)
            finally_callback && finally_callback();
        });
    }

    static get(url, params, success_callback, error_callback, finally_callback, with_auth_header=true, modal=false, loading_flag=true) {
        let headers = {};
        if(with_auth_header) {
            headers.Authorization = 'Token ' + GsuiteAuth.get('token');
        }
        loading_flag && setLoading(true)
        axios.get(url, {
            params: params,
            headers: headers
        }).then(res => {
            // do thomething
            if(res.data.Data){
                let tmp = res.data
                let result = tmp
                result.data = tmp.Data
                result.status = tmp.Code
                success_callback && success_callback(result);
            }else{
                success_callback && success_callback(res);
            }
            openRequestModal(res, modal)
        }).catch(error => {
            // do thomething
            console.log(error);
            // ステータスコード取得（AxiosError の場合）
            const status = error?.response?.status;

            // 不具合一覧 1939対応 + リロード対応
            if (error.code === "ERR_NETWORK" || status === 401) {
                GsuiteAuth.logout();

                // 🔄 ページをリロード
                window.location.reload();
            }
            error_callback && error_callback(error);
            openRequestModal(error)
            
        }).finally(() => {
            loading_flag && setLoading(false)
            finally_callback && finally_callback();
        });
    }

    static put(url, data, success_callback, error_callback, finally_callback, with_auth_header=true, modal=true) {
        let headers = {};
        if(with_auth_header) {
            headers.Authorization = 'Token ' + GsuiteAuth.get('token');
        }
        setLoading(true)
        axios.put(url, data ? data : {}, {headers: headers}).then(res => {
            // do thomething
            if(res.data.Data){
                let tmp = res.data
                let result = tmp
                result.data = tmp.Data
                result.status = tmp.Code
                success_callback && success_callback(result);
            }else{
                success_callback && success_callback(res);
            }
            openRequestModal(res, modal)
        }).catch(error => {
            // do thomething
            console.log(error);
            error_callback && error_callback(error);
            openRequestModal(error)
        }).finally(() => {
            setLoading(false)
            finally_callback && finally_callback();
        });
    }

    static patch(url, data, success_callback, error_callback, finally_callback, with_auth_header=true, modal=true) {
        let headers = {};
        if(with_auth_header) {
            headers.Authorization = 'Token ' + GsuiteAuth.get('token');
        }
        setLoading(true)
        axios.patch(url, data ? data : {}, {headers: headers}).then(res => {
            // do thomething
            if(res.data.Data){
                let tmp = res.data
                let result = tmp
                result.data = tmp.Data
                result.status = tmp.Code
                success_callback && success_callback(result);
            }else{
                success_callback && success_callback(res);
            }
            openRequestModal(res, modal)
        }).catch(error => {
            // do thomething

            console.log(error);
            error_callback && error_callback(error);
            openRequestModal(error)
        }).finally(() => {
            setLoading(false)
            finally_callback && finally_callback();
        });
    }

    static setProgress(value, progressMessage="処理中", underbarMessage){
        setProgress(value, progressMessage, underbarMessage)
    }

    render(){
        return <>
            {
                (this.state.progress>0||this.state.loading) && 
                <div style={{
                    width: "100%",
                    backgroundColor: "gray",
                    opacity: ".5",
                    height: "100%",
                    position: "fixed",
                    zIndex: "10000",
                }}>
                </div>
            }
            {
                this.state.progress>0 && 
                <div style={{
                    zIndex: "10001",
                    position:"fixed",
                    margin:'auto',
                    inset: 0,
                    width:'90%',
                    height: '80px',
                    backgroundColor:'white',
                    padding: '10px'}}>
                    {this.state.progressMessage&&<div style={{
                        textAlign: "center"
                    }}>
                    {this.state.progressMessage}
                    </div>}
                    <div style={{
                        backgroundColor: "hsl(209deg 81% 92%)"
                    }}>
                        <Progress  bar animated color="info" value={this.state.progress}>{this.state.progress}%</Progress>
                    </div>
                    {this.state.underbarMessage&&<div style={{
                        textAlign: "center"
                    }}>
                    {this.state.underbarMessage}
                    </div>}
                </div>
            }
        </>
    }

    static getObjectCommon() {
        const today = new Date()
        
        return {
            api_today:Format.dateToString(today, 'YYYY/MM/D'),
            api_today_jpn:Format.dateToString(today, 'JJY年MM月D日'),
            array_count:0
        }
    }

    static getUserParameters(user_branch_natural_id=null){
        return new Promise(resolve=>{
            if (user_branch_natural_id) {
                this.get('/api/landmark/user_branch', {
                    user_branch_natural_id
                }, res=>{
                    if (!res.Data[0]){
                        Request.setProgress(0)
                        throw {
                            name:'Data Error!',
                            message:'UserBranch not exist'
                        }
                    }
                    const result = {
                        USER__name:GsuiteAuth.get('name') || "",
                        USER__user_cc_email:GsuiteAuth.get('user_cc_email') || "",
                        USER__is_active:GsuiteAuth.get('is_active')=="true"?true:false,
                        USER__is_staff:GsuiteAuth.get('is_staff'),
                        USER__employee_type:GsuiteAuth.get('employee_type') || "",
                        USER__first_name:GsuiteAuth.get('first_name') || "",
                        USER__last_name:GsuiteAuth.get('last_name') || "",
                        USER__email:GsuiteAuth.get('email') || "",
                        USER__division_name:GsuiteAuth.get('division_name') || "",
                        USER_BRANCH__user_branch_name: res.Data[0].user_branch_name || "",
                        USER_BRANCH__user_branch_zip_code: res.Data[0].user_branch_zip_code || "",
                        USER_BRANCH__user_branch_prefecture: res.Data[0].user_branch_prefecture || "",
                        USER_BRANCH__user_branch_address: res.Data[0].user_branch_address || "",
                        USER_BRANCH__user_branch_tel: res.Data[0].user_branch_tel || "",
                        USER_BRANCH__user_branch_fax: res.Data[0].user_branch_fax || "",
                        USER__share_email:GsuiteAuth.get('share_email') || "", // TO DO : check if its right
                        USER__user_tel:GsuiteAuth.get('user_tel') || "", // TO DO : not exist 2020/05/29
                        USER_BRANCH__user_branch_city: res.Data[0].user_branch_city || "",
                        JOIN_user_branch_user_addr : FormatCode.decode("cst_prefecture", res.Data[0].user_branch_prefecture) + (res.Data[0].user_branch_city || "") + (res.Data[0].user_branch_address || "")
                    }
                    resolve(result)
                })
            } else {
                const result = {
                    USER__name:GsuiteAuth.get('name') || "",
                    USER__user_cc_email:GsuiteAuth.get('user_cc_email') || "",
                    USER__is_active:GsuiteAuth.get('is_active')=="true"?true:false,
                    USER__is_staff:GsuiteAuth.get('is_staff'),
                    USER__employee_type:GsuiteAuth.get('employee_type') || "",
                    USER__first_name:GsuiteAuth.get('first_name') || "",
                    USER__last_name:GsuiteAuth.get('last_name') || "",
                    USER__email:GsuiteAuth.get('email') || "",
                    USER__division_name:GsuiteAuth.get('division_name') || "",
                    USER_BRANCH__user_branch_name:GsuiteAuth.get('user_branch_name') || "",
                    USER_BRANCH__user_branch_zip_code:GsuiteAuth.get('user_branch_zip_code') || "",
                    USER_BRANCH__user_branch_prefecture:GsuiteAuth.get('user_branch_prefecture') || "",
                    USER_BRANCH__user_branch_address:GsuiteAuth.get('user_branch_address') || "",
                    USER_BRANCH__user_branch_tel:GsuiteAuth.get('user_branch_tel') || "",
                    USER_BRANCH__user_branch_fax:GsuiteAuth.get('user_branch_fax') || "",
                    USER__share_email:GsuiteAuth.get('share_email') || "", // TO DO : check if its right
                    USER__user_tel:GsuiteAuth.get('user_tel') || "", // TO DO : not exist 2020/05/29
                    USER_BRANCH__user_branch_city:GsuiteAuth.get('user_branch_city') || "",
                    JOIN_user_branch_user_addr : FormatCode.decode("cst_prefecture",GsuiteAuth.get('user_branch_prefecture')) + (GsuiteAuth.get('user_branch_city') || "") + (GsuiteAuth.get('user_branch_address') || "")
                }
                resolve(result)
            }
        })
    }

    static getCustomerBranch(customer_branch_natural_id,subcontract_flag=false){
        return new Promise(resolve=>{
            if (!customer_branch_natural_id && subcontract_flag == true){
                const result = {
                    CUSTOMER_BRANCH__customer_branch_name: "",
                    CUSTOMER_BRANCH__customer_branch_tel: "",
                    CUSTOMER_BRANCH__customer_branch_fax: "",
                    JOIN_customer_branch_user_addr: "",
                    CUSTOMER_BRANCH__customer_branch_zip_code: "",
                    CUSTOMER__customer_name: "",
                    CUSTOMER_BRANCH__customer_branch_invoice_zip_code:"",
                    CUSTOMER_BRANCH__customer_branch_invoice_prefecture:"",
                    CUSTOMER_BRANCH__customer_branch_invoice_city:"",
                    CUSTOMER_BRANCH__customer_branch_invoice_address:"",                    
                    JOIN_invoice_addr: "",
                    CUSTOMER_BRANCH__invoice_bank_name: "",
                    CUSTOMER_BRANCH__invoice_bank_branch_name: "",
                    CUSTOMER_BRANCH__invoice_bank_account_kana: "",
                    CUSTOMER_BRANCH__invoice_bank_account_type: "",
                    CUSTOMER_BRANCH__invoice_bank_account_number: "",
                    JOIN_payment_bank_type_number: "",
                    CUSTOMER_BRANCH__estimate_format_url: "",
                    CUSTOMER_BRANCH__invoice_format_url: "",
                    CUSTOMER_BRANCH__contract_format_url: "",
                    CUSTOMER_BRANCH__send_letter_format_url: "",
                    CUSTOMER_BRANCH__inhouse1_format_url: "",
                    CUSTOMER_BRANCH__inhouse2_format_url: "",
                    CUSTOMER_BRANCH__invoice_list_format_url: "",
                    CUSTOMER_BRANCH__basic_contract_signing_date : "",
                    CUSTOMER_BRANCH__customer_branch_cc_email: "",
                    CUSTOMER_BRANCH__customer_branch_cc_email_quote: "",
                    CUSTOMER_BRANCH__tax_in_flag: "",
                }
                resolve(result)
            }


            this.get('/api/customer/branch', {
                customer_branch_natural_id
            }, res=>{
                if (!res.Data[0]){
                    Request.setProgress(0)
                    throw {
                        name:'Data Error!',
                        message:'CustomerBranch not exist'
                    }
                }
                // console.log(res.Data[0]);
                const {
                    id,
                    customer_id,
                    customer_branch_name,
                    customer_branch_tel,
                    customer_branch_fax,
                    customer_branch_prefecture,
                    customer_branch_city,
                    customer_branch_address,
                    customer_name,
                    customer_branch_zip_code,
                    customer_branch_invoice_zip_code,
                    customer_branch_invoice_prefecture,
                    customer_branch_invoice_city,
                    customer_branch_invoice_address,                    
                    invoice_bank_name,
                    invoice_bank_branch_name,
                    invoice_bank_account_kana,
                    invoice_bank_account_type,
                    invoice_bank_account_number,
                    invoice_format_url,
                    contract_format_url,
                    send_letter_format_url,
                    inhouse1_format_url,
                    inhouse2_format_url,
                    invoice_list_format_url,
                    estimate_format_url,
                    basic_contract_signing_date,
                    customer_branch_cc_email,
                    customer_branch_cc_email_quote,
                    tax_in_flag,
                    customer_branch_noname_flag,
                    invoice_create_flag,
                    contract_create_flag,
                    invoice_list_create_flag,
                    customer_list_invoice_zip_code,
                    customer_list_invoice_prefecture,
                    customer_list_invoice_city,
                    customer_list_invoice_address,
                } = res.Data[0]
                const result = {
                    CUSTOMER_BRANCH__id:id,
                    CUSTOMER__id:customer_id,
                    CUSTOMER_BRANCH__customer_branch_name: customer_branch_noname_flag  == 1 ? "" : customer_branch_name,
                    CUSTOMER_BRANCH__customer_branch_tel: customer_branch_tel,
                    CUSTOMER_BRANCH__customer_branch_fax: customer_branch_fax,
                    JOIN_customer_branch_user_addr: FormatCode.decode("cst_prefecture", customer_branch_prefecture) + (customer_branch_city||"") + (customer_branch_address||""),
                    CUSTOMER_BRANCH__customer_branch_zip_code: customer_branch_zip_code,
                    CUSTOMER__customer_name: customer_name,
                    CUSTOMER_BRANCH__customer_branch_invoice_zip_code:customer_branch_invoice_zip_code,
                    CUSTOMER_BRANCH__customer_branch_invoice_list_zip_code:customer_list_invoice_zip_code,
                    CUSTOMER_BRANCH__customer_branch_invoice_prefecture:customer_branch_invoice_prefecture,
                    CUSTOMER_BRANCH__customer_branch_invoice_city:customer_branch_invoice_city,
                    CUSTOMER_BRANCH__customer_branch_invoice_address:customer_branch_invoice_address,
                    JOIN_invoice_addr: FormatCode.decode("cst_prefecture", customer_branch_invoice_prefecture) + (customer_branch_invoice_city||"") + (customer_branch_invoice_address||""),
                    JOIN_invoice_list_addr: FormatCode.decode("cst_prefecture", customer_list_invoice_prefecture) + (customer_list_invoice_city||"") + (customer_list_invoice_address||""),
                    CUSTOMER_BRANCH__invoice_bank_name: invoice_bank_name,
                    CUSTOMER_BRANCH__invoice_bank_branch_name: invoice_bank_branch_name,
                    CUSTOMER_BRANCH__invoice_bank_account_kana: invoice_bank_account_kana,
                    CUSTOMER_BRANCH__invoice_bank_account_type: FormatCode.decode("cst_payment_bank_account_type", invoice_bank_account_type),
                    CUSTOMER_BRANCH__invoice_bank_account_number: invoice_bank_account_number,
                    JOIN_payment_bank_type_number: invoice_bank_name + invoice_bank_branch_name + invoice_bank_account_type + invoice_bank_account_number,
                    CUSTOMER_BRANCH__estimate_format_url: estimate_format_url,
                    CUSTOMER_BRANCH__invoice_format_url: invoice_format_url,
                    CUSTOMER_BRANCH__contract_format_url: contract_format_url,
                    CUSTOMER_BRANCH__send_letter_format_url: send_letter_format_url,
                    CUSTOMER_BRANCH__inhouse1_format_url: inhouse1_format_url,
                    CUSTOMER_BRANCH__inhouse2_format_url: inhouse2_format_url,
                    CUSTOMER_BRANCH__invoice_list_format_url: invoice_list_format_url,
                    CUSTOMER_BRANCH__basic_contract_signing_date : basic_contract_signing_date,
                    CUSTOMER_BRANCH__customer_branch_cc_email: customer_branch_cc_email,
                    CUSTOMER_BRANCH__customer_branch_cc_email_quote: customer_branch_cc_email_quote,
                    CUSTOMER_BRANCH__tax_in_flag: FormatCode.decode("cst_tax_in_flag", tax_in_flag),
                    invoice_create_flag,
                    contract_create_flag,
                    invoice_list_create_flag
                }
                resolve(result)
            })
        })
    }

    static getCustomerUser(customer_user_natural_id,subcontract_flag=false){
        return new Promise(resolve=>{
            if (!customer_user_natural_id && subcontract_flag == true){
                const result = {
                    CUSTOMER_USER__customer_user_division_name: "",
                    CUSTOMER_USER__customer_user_name: "",
                    CUSTOMER_USER__customer_user_email: "",
                    CUSTOMER_USER__customer_user_tel: "",
                    CUSTOMER_USER__notification_flag: "",
                    CUSTOMER_USER__customer_reminder_sms_flag: "",
                    CUSTOMER_USER__customer_reminder_sms_flag_code: ""
                }
                resolve(result) 
            }

            this.get('/api/customer/user', {
                customer_user_natural_id
            }, res=>{
                if (!res.Data[0]){
                    Request.setProgress(0)
                    throw {
                        name:'Data Error!',
                        message:'CustomerUser not exist'
                    }

                }
                const {
                    id,
                    customer_user_division_name,
                    customer_user_name,
                    customer_user_email,
                    customer_user_tel,
                    customer_reminder_sms_flag,
                    notification_flag,
                } = res.Data[0]
                // PUSH通知がオンの場合、device情報をチェック
                if(notification_flag == "1"){
                    this.get('/api/check/PUSH', {
                        customer_user_id:id
                    }, push=>{
                        console.log(push.Data)
                        let result = {
                            CUSTOMER_USER__id:id,
                            CUSTOMER_USER__customer_user_division_name: customer_user_division_name,
                            CUSTOMER_USER__customer_user_name: customer_user_name,
                            CUSTOMER_USER__customer_user_email: customer_user_email,
                            CUSTOMER_USER__customer_user_tel: customer_user_tel,
                            CUSTOMER_USER__notification_flag: "0",
                            CUSTOMER_USER__customer_reminder_sms_flag: FormatCode.decode("cst_reminder_sms_flag", customer_reminder_sms_flag),
                            CUSTOMER_USER__customer_reminder_sms_flag_code: customer_reminder_sms_flag,
                        }

                        if(push.Code <= "200"){
                            result["CUSTOMER_USER__notification_flag"] = push.Data.token ? "1" : "0";
                        }
                        resolve(result)
                    })
                   
                }else{

                    const result = {
                        CUSTOMER_USER__id:id,
                        CUSTOMER_USER__customer_user_division_name: customer_user_division_name,
                        CUSTOMER_USER__customer_user_name: customer_user_name,
                        CUSTOMER_USER__customer_user_email: customer_user_email,
                        CUSTOMER_USER__customer_user_tel: customer_user_tel,
                        CUSTOMER_USER__notification_flag: notification_flag,
                        CUSTOMER_USER__customer_reminder_sms_flag: FormatCode.decode("cst_reminder_sms_flag", customer_reminder_sms_flag),
                        CUSTOMER_USER__customer_reminder_sms_flag_code: customer_reminder_sms_flag,
                    }
                    resolve(result)
                }

            })
        })
    }

    static getProject(project_natural_id){
        return new Promise(resolve=>{
            this.get('/api/construction/report', {
                project_natural_id
            }, res=>{
                if (!res.Data[0]){
                    Request.setProgress(0)
                    throw {
                      name:'Data Error!',
                      message:'Project not exist'
                    }
                }
                const {
                    project_natural_id,
                    construction_number,
                    site_name,
                    site_address,
                    site_city,
                    site_prefecture,
                    send_destination_type,
                    register_type,
                    site_customer_user_name,
                    site_customer_user_tel
                } = res.Data[0]
                const result = {
                    PROJECT__project_natural_id: project_natural_id,
                    PROJECT__construction_number: construction_number,
                    PROJECT__site_name: site_name,
                    JOIN_project_addr: FormatCode.decode("cst_prefecture",site_prefecture) + (site_city||"") + (site_address||""),
                    PROJECT__send_destination_type:send_destination_type,
                    PROJECT__register_type:register_type,
                    PROJECT__site_customer_user_name:site_customer_user_name,
                    PROJECT__site_customer_user_tel:site_customer_user_tel
                }
                resolve(result)
            })
        })
    }
    
    static getRequest(request_natural_id){
        return new Promise(resolve=>{
            this.get('/api/request', {
                all_survey_status:true,
                request_natural_id
            }, res=>{
                if (!res.Data[0]){
                    Request.setProgress(0)
                    throw {
                      name:'Data Error!',
                      message:'Request not exist'
                    }
                }
                const {
                    id,
                    request_type,
                    cc_email,
                    estimate_deadline,
                    lastupdate_user_id,
                    web_survey_account,
                    onsite_survey_account,
                    want_guide_type
                } = res.Data[0]
                const result = {
                    REQUEST__id:id,
                    REQUEST__request_type: FormatCode.decode("cst_request_type", request_type),
                    REQUEST__cc_email: cc_email || "",
                    REQUEST__estimate_deadline: estimate_deadline,
                    lastupdate_user_id,
                    web_survey_account,
                    onsite_survey_account,
                    want_guide_type
                }
                resolve(result)
            })
        })
    }
    
    static getRequestOther(request_natural_id){
        return new Promise(resolve=>{
            this.get('/api/request/other', {
                all_survey_status:true,
                request_natural_id
            }, res=>{
                if (!res.Data[0]){
                    Request.setProgress(0)
                    throw {
                      name:'Data Error!',
                      message:'Request Other not exist'
                    }
                }
                const {
                    request_type,
                    cc_email,
                    estimate_deadline,
                } = res.Data[0]
                const result = {
                    REQUEST__request_type: FormatCode.decode("cst_request_type", request_type),
                    REQUEST__cc_email: cc_email || "",
                    REQUEST__estimate_deadline: estimate_deadline,
                }
                resolve(result)
            })
        })
    }

    static getUser(user_id){
        return new Promise(resolve=>{
            this.get('/api/landmark/user', {
                user_id,
                all_flag : true // 不具合一覧No.765対応
            }, res=>{
                if (!res.Data[0]){
                    Request.setProgress(0)
                    throw {
                      name:'Data Error!',
                      message:'User not exist'
                    }
                }
                const {
                    id,
                    name,
                    user_tel,
                    email,
                    user_cc_email,
                    user_branch_natural_id
                } = res.Data[0]
                const result = {
                    user_branch_natural_id,
                    USER__id:id,
                    USER__name: name,
                    USER__user_tel: user_tel,
                    USER__email: email,
                    USER__user_cc_email: user_cc_email,
                }
                resolve(result)
            })
        })
    }

    static getUserBranch(user_branch_natural_id){
        return new Promise(resolve=>{
            this.get('/api/landmark/user_branch', {
                user_branch_natural_id
            }, res=>{
                if (!res.Data[0]){
                    Request.setProgress(0)
                    throw {
                      name:'Data Error!',
                      message:'UserBranch not exist'
                    }
                }
                const {
                    user_branch_name,
                    user_branch_zip_code,
                    user_branch_tel,
                    user_branch_fax,
                    user_branch_prefecture,
                    user_branch_city,
                    user_branch_address
                } = res.Data[0]
                const JOIN_user_branch_user_addr = FormatCode.decode("cst_prefecture", user_branch_prefecture) + (user_branch_city||"") + (user_branch_address||"")
                const result = {
                    USER_BRANCH__user_branch_name:user_branch_name,
                    USER_BRANCH__user_branch_zip_code:user_branch_zip_code,
                    USER_BRANCH__user_branch_tel:user_branch_tel,
                    USER_BRANCH__user_branch_fax:user_branch_fax,
                    JOIN_user_branch_user_addr
                }
                resolve(result)
            })
        })
    }

    static getEstimate(estimate_natural_id,contract_flag=false){
        const extension_flag = contract_flag ? 0 : 1

        return new Promise(resolve=>{
            this.get('/api/order', {
                estimate_natural_id,
                extension_flag:extension_flag
            }, res=>{
                if (!res.Data[0]){
                    Request.setProgress(0)
                    throw {
                      name:'Data Error!',
                      message:'Estimate not exist'
                    }
                }
                const {
                    estimate_natural_id,
                    survey_parking_name,
                    survey_parking_prefecture,
                    survey_parking_city,
                    survey_parking_address,
                    
                    survey_parking_address_contract,
                    latest_pdf_route_url,
                    survey_site_distance_minute,
                    survey_site_distance_meter,
                    survey_capacity_flag_car,
                    survey_capacity_flag_truck,
                    survey_capacity_flag_light_truck,
                    survey_available_start_date,
                    survey_available_end_date,
                    survey_capacity_qty,
                    survey_capacity_qty_type,
                    survey_pay_unit_type_day,
                    survey_pay_unit_type_month,
                    survey_parking_rent,
                    survey_key_money,
                    survey_commission_discount_amt,
                    survey_commission_discount_rate,
                    survey_commission,
                    survey_discount_amt,
                    survey_adjustment_amt,
                    survey_subtotal_amt,
                    survey_tax_amt,
                    survey_total_amt,
                    
                    survey_cost_parking_rent,

                    survey_tax_in_flag,

                    quote_plotting_picture_url,
                    quote_plotting_number,
                    quote_available_start_date,
                    quote_available_end_date,
                    quote_capacity_qty,
                    quote_subtotal_amt,
                    quote_tax_amt,
                    quote_total_amt,
                    
                    latest_pdf_quote_url,
                } = res.Data[0]
                const result = {
                    object_estimate:{
                        ESTIMATE__estimate_natural_id:estimate_natural_id,
                        ESTIMATE__survey_parking_name:survey_parking_name,
                        JOIN_parking_addr:FormatCode.decode("cst_prefecture", survey_parking_prefecture) + (survey_parking_city||"") + (survey_parking_address||""),
                        ESTIMATE__survey_parking_address_contract: survey_parking_address_contract||"",
                        ESTIMATE__latest_pdf_route_url: latest_pdf_route_url||"",
                        ESTIMATE__survey_site_distance_minute: survey_site_distance_minute,
                        ESTIMATE__survey_site_distance_meter: survey_site_distance_meter,
                        ESTIMATE__survey_capacity_flag_car: FormatCode.decode("cst_ab_select", survey_capacity_flag_car)||"",
                        ESTIMATE__survey_capacity_flag_truck: FormatCode.decode("cst_ab_select", survey_capacity_flag_truck)||"",
                        ESTIMATE__survey_capacity_flag_light_truck: FormatCode.decode("cst_ab_select", survey_capacity_flag_light_truck)||"",
                        ESTIMATE__survey_available_start_date: survey_available_start_date,
                        ESTIMATE__survey_available_end_date: survey_available_end_date,
                        ESTIMATE__survey_capacity_qty: survey_capacity_qty,
                        ESTIMATE__survey_capacity_qty_type:FormatCode.decode("cst_survey_capacity_qty_type",survey_capacity_qty_type),
                        ESTIMATE__survey_pay_unit_type_day: FormatCode.decode("cst_pay_unit_type_day",survey_pay_unit_type_day),
                        ESTIMATE__survey_pay_unit_type_month: FormatCode.decode("cst_pay_unit_type_month",survey_pay_unit_type_month),
                        CALC__survey_parking_rent_day: isNaN(parseInt(survey_cost_parking_rent/30))? "": parseInt(survey_cost_parking_rent/30),
                        ESTIMATE__survey_parking_rent: survey_parking_rent,
                        ESTIMATE__survey_key_money: survey_key_money,
                        ESTIMATE__survey_commission_discount_amt: survey_commission_discount_amt,
                        ESTIMATE__survey_commission_discount_rate : survey_commission_discount_rate,
                        ESTIMATE__survey_commission: survey_commission,
                        ESTIMATE__survey_discount_amt: survey_discount_amt,
                        ESTIMATE__survey_adjustment_amt: survey_adjustment_amt,
                        ESTIMATE__survey_subtotal_amt: survey_subtotal_amt,
                        ESTIMATE__survey_tax_amt: survey_tax_amt,
                        ESTIMATE__survey_total_amt: survey_total_amt,
        
                        ESTIMATE__quote_plotting_picture_url: GoogleDrive.getDownloadUrl(quote_plotting_picture_url),
                        ESTIMATE__quote_plotting_number: quote_plotting_number,
                        ESTIMATE__quote_available_start_date: quote_available_start_date,
                        ESTIMATE__quote_available_end_date: quote_available_end_date,
                        ESTIMATE__quote_capacity_qty: quote_capacity_qty,
                        ESTIMATE__quote_subtotal_amt: quote_subtotal_amt,
                        ESTIMATE__quote_tax_amt: quote_tax_amt,
                        ESTIMATE__quote_total_amt: quote_total_amt,

                        ESTIMATE__latest_pdf_quote_url: latest_pdf_quote_url,

                        ESTIMATE__survey_tax_in_flag: FormatCode.decode("cst_tax_in_flag", survey_tax_in_flag),
                    },
                }
                resolve(result)
            })
        })
    }

    static async getRequestCommon({
        customer_branch_natural_id,
        customer_user_natural_id,
        project_natural_id,
        subcontract_customer_branch_natural_id,
        subcontract_customer_user_natural_id,
        REQUEST__request_type,
        REQUEST__cc_email = "",
        REQUEST__estimate_deadline,
        user_branch_natural_id,
        site_customer_user_tel
    }){
        const {
            USER__name,
            USER__user_tel,
            USER__email,
            USER__user_cc_email,
            USER_BRANCH__user_branch_name,
            USER_BRANCH__user_branch_zip_code,
            USER_BRANCH__user_branch_tel,
            USER_BRANCH__user_branch_fax,
            JOIN_user_branch_user_addr
        }= await this.getUserParameters(user_branch_natural_id)
        const {
            CUSTOMER_BRANCH__customer_branch_zip_code,
            CUSTOMER__customer_name,
            CUSTOMER_BRANCH__customer_branch_name,
            CUSTOMER_BRANCH__customer_branch_tel,
            CUSTOMER_BRANCH__customer_branch_fax,
            JOIN_customer_branch_user_addr,
            CUSTOMER_BRANCH__estimate_format_url,
            CUSTOMER_BRANCH__invoice_format_url,
            CUSTOMER_BRANCH__contract_format_url,
            CUSTOMER_BRANCH__send_letter_format_url,
            CUSTOMER_BRANCH__customer_branch_cc_email,
            CUSTOMER_BRANCH__customer_branch_cc_email_quote,
            CUSTOMER_BRANCH__tax_in_flag
        } = await this.getCustomerBranch(customer_branch_natural_id)
        const {
            CUSTOMER_USER__id,
            CUSTOMER_USER__customer_user_division_name,
            CUSTOMER_USER__customer_user_name,
            CUSTOMER_USER__customer_user_email,
            CUSTOMER_USER__customer_user_tel,
            CUSTOMER_USER__customer_reminder_sms_flag,
            CUSTOMER_USER__customer_reminder_sms_flag_code
        } = await this.getCustomerUser(customer_user_natural_id)

        const {
            CUSTOMER_BRANCH__customer_branch_zip_code:subcontract_CUSTOMER_BRANCH__customer_branch_zip_code,
            CUSTOMER__customer_name:subcontract_CUSTOMER__customer_name,
            CUSTOMER_BRANCH__customer_branch_name:subcontract_CUSTOMER_BRANCH__customer_branch_name,
            CUSTOMER_BRANCH__customer_branch_tel:subcontract_CUSTOMER_BRANCH__customer_branch_tel,
            CUSTOMER_BRANCH__customer_branch_fax:subcontract_CUSTOMER_BRANCH__customer_branch_fax,
            JOIN_customer_branch_user_addr:subcontract_JOIN_customer_branch_user_addr,
            CUSTOMER_BRANCH__customer_branch_cc_email: subcontract_CUSTOMER_BRANCH__customer_branch_cc_email,
            CUSTOMER_BRANCH__customer_branch_cc_email_quote: subcontract_CUSTOMER_BRANCH__customer_branch_cc_email_quote,
            CUSTOMER_BRANCH__tax_in_flag:subcontract_CUSTOMER_BRANCH__tax_in_flag
        } = (subcontract_customer_branch_natural_id && await this.getCustomerBranch(subcontract_customer_branch_natural_id))||{}
        const {
            CUSTOMER_USER__customer_user_division_name:subcontract_CUSTOMER_USER__customer_user_division_name,
            CUSTOMER_USER__customer_user_name:subcontract_CUSTOMER_USER__customer_user_name,
            CUSTOMER_USER__customer_user_email:subcontract_CUSTOMER_USER__customer_user_email,
            CUSTOMER_USER__customer_user_tel:subcontract_CUSTOMER_USER__customer_user_tel,
            CUSTOMER_USER__customer_reminder_sms_flag:subcontract_CUSTOMER_USER__customer_reminder_sms_flag,
            CUSTOMER_USER__customer_reminder_sms_flag_code:subcontract_CUSTOMER_USER__customer_reminder_sms_flag_code,
        } = (subcontract_customer_user_natural_id && await this.getCustomerUser(subcontract_customer_user_natural_id)) || {}

        const {
            PROJECT__project_natural_id,
            PROJECT__construction_number,
            PROJECT__site_name,
            JOIN_project_addr,
            PROJECT__send_destination_type,
            PROJECT__register_type,
            PROJECT__site_customer_user_tel
        } = await this.getProject(project_natural_id)
        
        return {
            CUSTOMER_BRANCH__estimate_format_url,
            CUSTOMER_BRANCH__invoice_format_url,
            CUSTOMER_BRANCH__contract_format_url,
            CUSTOMER_BRANCH__send_letter_format_url,
            object_common:this.getObjectCommon(),
            object_user:{
                USER_BRANCH__user_branch_name,
                USER_BRANCH__user_branch_zip_code,
                USER_BRANCH__user_branch_tel,
                USER_BRANCH__user_branch_fax,
                USER__name,
                USER__user_tel,
                USER__email,
                USER__user_cc_email,
                JOIN_user_branch_user_addr
            },
            object_customer:{
                CUSTOMER__customer_name,
                CUSTOMER_BRANCH__customer_branch_name,
                CUSTOMER_BRANCH__customer_branch_zip_code,
                CUSTOMER_BRANCH__customer_branch_tel,
                CUSTOMER_BRANCH__customer_branch_fax,
                JOIN_customer_branch_user_addr,
                CUSTOMER_USER__id,
                CUSTOMER_USER__customer_user_division_name,
                CUSTOMER_USER__customer_user_name,
                CUSTOMER_USER__customer_user_email,
                CUSTOMER_USER__customer_user_tel,
                CUSTOMER_USER__customer_reminder_sms_flag,
                CUSTOMER_USER__customer_reminder_sms_flag_code,
                CUSTOMER_BRANCH__tax_in_flag,
                CUSTOMER_BRANCH__customer_branch_cc_email: [
                    ...(CUSTOMER_BRANCH__customer_branch_cc_email?CUSTOMER_BRANCH__customer_branch_cc_email.split(','):[]),
                    ...(REQUEST__cc_email?REQUEST__cc_email.split(','):[])
                ].join(','),
                CUSTOMER_BRANCH__customer_branch_cc_email_quote: [
                    ...(CUSTOMER_BRANCH__customer_branch_cc_email_quote?CUSTOMER_BRANCH__customer_branch_cc_email_quote.split(','):[]),
                    ...(REQUEST__cc_email?REQUEST__cc_email.split(','):[])
                ].join(',')
            },
            object_customer_subcontract:{
                CUSTOMER__customer_name:subcontract_CUSTOMER__customer_name||"",
                CUSTOMER_BRANCH__customer_branch_name:subcontract_CUSTOMER_BRANCH__customer_branch_name||"",
                CUSTOMER_BRANCH__customer_branch_zip_code:subcontract_CUSTOMER_BRANCH__customer_branch_zip_code||"",
                CUSTOMER_BRANCH__customer_branch_tel:subcontract_CUSTOMER_BRANCH__customer_branch_tel||"",
                CUSTOMER_BRANCH__customer_branch_fax:subcontract_CUSTOMER_BRANCH__customer_branch_fax||"",
                JOIN_customer_branch_user_addr:subcontract_JOIN_customer_branch_user_addr||"",
                JOIN_subcontract_customer_branch_addr:subcontract_JOIN_customer_branch_user_addr||"",
                CUSTOMER_USER__customer_user_division_name:subcontract_CUSTOMER_USER__customer_user_division_name||"",
                CUSTOMER_USER__customer_user_name:subcontract_CUSTOMER_USER__customer_user_name||"",
                CUSTOMER_USER__customer_user_email:subcontract_CUSTOMER_USER__customer_user_email||"",
                CUSTOMER_USER__customer_user_tel:subcontract_CUSTOMER_USER__customer_user_tel||"",
                CUSTOMER_USER__customer_reminder_sms_flag:subcontract_CUSTOMER_USER__customer_reminder_sms_flag||"",
                CUSTOMER_USER__customer_reminder_sms_flag_code:subcontract_CUSTOMER_USER__customer_reminder_sms_flag_code||"",
                CUSTOMER_BRANCH__customer_branch_cc_email: [
                    ...(subcontract_CUSTOMER_BRANCH__customer_branch_cc_email?subcontract_CUSTOMER_BRANCH__customer_branch_cc_email.split(','):[]),
                    ...(REQUEST__cc_email?REQUEST__cc_email.split(','):[])
                ].join(','),
                CUSTOMER_BRANCH__customer_branch_cc_email_quote: [
                    ...(subcontract_CUSTOMER_BRANCH__customer_branch_cc_email_quote?subcontract_CUSTOMER_BRANCH__customer_branch_cc_email_quote.split(','):[]),
                    ...(REQUEST__cc_email?REQUEST__cc_email.split(','):[])
                ].join(','),
                CUSTOMER_BRANCH__tax_in_flag:subcontract_CUSTOMER_BRANCH__tax_in_flag||""
            },
            object_project:{
                PROJECT__project_natural_id,
                PROJECT__construction_number,
                PROJECT__site_name,
                JOIN_project_addr,
                PROJECT__send_destination_type,
                PROJECT__register_type,
                PROJECT__site_customer_user_tel,
            },
            object_request:{
                REQUEST__request_type,
                REQUEST__cc_email,
                REQUEST__estimate_deadline,
            },
            site_customer_user_tel: site_customer_user_tel || "",
            debug_msg:""
        }
    }

    static async getEstimateCommon({
        customer_branch_natural_id,
        customer_user_natural_id,
        project_natural_id,
        request_natural_id,
        subcontract_customer_branch_natural_id,
        subcontract_customer_user_natural_id,
        estimateObject,
        user_branch_natural_id,
        request_type = 0
    }){
        // const user_branch_natural_id_for_user_info = estimateObject.lastupdate_user_id
        //     ? (await this.getUser(estimateObject.lastupdate_user_id)).user_branch_natural_id 
        //     : user_branch_natural_id
        const user_branch_natural_id_for_user_info = user_branch_natural_id 
                ? user_branch_natural_id
                : (await this.getUser(estimateObject.lastupdate_user_id)).user_branch_natural_id 
        const {
            USER__name,
            USER__user_tel,
            USER__email,
            USER__user_cc_email,
            USER_BRANCH__user_branch_name,
            USER_BRANCH__user_branch_zip_code,
            USER_BRANCH__user_branch_tel,
            USER_BRANCH__user_branch_fax,
            JOIN_user_branch_user_addr
        }= await this.getUserParameters(user_branch_natural_id_for_user_info)
        
        const {
            CUSTOMER_BRANCH__customer_branch_zip_code,
            CUSTOMER__customer_name,
            CUSTOMER_BRANCH__customer_branch_name,
            CUSTOMER_BRANCH__customer_branch_tel,
            CUSTOMER_BRANCH__customer_branch_fax,
            JOIN_customer_branch_user_addr,
            CUSTOMER_BRANCH__estimate_format_url,
            CUSTOMER_BRANCH__invoice_format_url,
            CUSTOMER_BRANCH__contract_format_url,
            CUSTOMER_BRANCH__send_letter_format_url,
            CUSTOMER_BRANCH__customer_branch_cc_email,
            CUSTOMER_BRANCH__customer_branch_cc_email_quote,
            CUSTOMER_BRANCH__tax_in_flag,
            CUSTOMER_BRANCH__id,
            CUSTOMER__id,
        } = await this.getCustomerBranch(customer_branch_natural_id)
        const {
            CUSTOMER_USER__id,
            CUSTOMER_USER__customer_user_division_name,
            CUSTOMER_USER__customer_user_name,
            CUSTOMER_USER__customer_user_email,
            CUSTOMER_USER__customer_user_tel,
            CUSTOMER_USER__notification_flag,
            CUSTOMER_USER__customer_reminder_sms_flag,
            CUSTOMER_USER__customer_reminder_sms_flag_code
        } = await this.getCustomerUser(customer_user_natural_id)

        const {
            CUSTOMER_BRANCH__customer_branch_zip_code:subcontract_CUSTOMER_BRANCH__customer_branch_zip_code,
            CUSTOMER__customer_name:subcontract_CUSTOMER__customer_name,
            CUSTOMER_BRANCH__customer_branch_name:subcontract_CUSTOMER_BRANCH__customer_branch_name,
            CUSTOMER_BRANCH__customer_branch_tel:subcontract_CUSTOMER_BRANCH__customer_branch_tel,
            CUSTOMER_BRANCH__customer_branch_fax:subcontract_CUSTOMER_BRANCH__customer_branch_fax,
            JOIN_customer_branch_user_addr:subcontract_JOIN_customer_branch_user_addr,
            CUSTOMER_BRANCH__customer_branch_cc_email: subcontract_CUSTOMER_BRANCH__customer_branch_cc_email,
            CUSTOMER_BRANCH__customer_branch_cc_email_quote: subcontract_CUSTOMER_BRANCH__customer_branch_cc_email_quote,
            CUSTOMER_BRANCH__tax_in_flag:subcontract_CUSTOMER_BRANCH__tax_in_flag
        } = (subcontract_customer_branch_natural_id && await this.getCustomerBranch(subcontract_customer_branch_natural_id))||{}
        const {
            CUSTOMER_USER__customer_user_division_name:subcontract_CUSTOMER_USER__customer_user_division_name,
            CUSTOMER_USER__customer_user_name:subcontract_CUSTOMER_USER__customer_user_name,
            CUSTOMER_USER__customer_user_email:subcontract_CUSTOMER_USER__customer_user_email,
            CUSTOMER_USER__customer_user_tel:subcontract_CUSTOMER_USER__customer_user_tel,
            CUSTOMER_USER__customer_reminder_sms_flag:subcontract_CUSTOMER_USER__customer_reminder_sms_flag,
            CUSTOMER_USER__customer_reminder_sms_flag_code:subcontract_CUSTOMER_USER__customer_reminder_sms_flag_code
        } = (subcontract_customer_user_natural_id && await this.getCustomerUser(subcontract_customer_user_natural_id))||{}

        const {
            PROJECT__project_natural_id,
            PROJECT__construction_number,
            PROJECT__site_name,
            JOIN_project_addr,
            PROJECT__send_destination_type ,
            PROJECT__register_type,
            PROJECT__site_customer_user_tel
        } = await this.getProject(project_natural_id)
        const {
            REQUEST__id,
            REQUEST__request_type,
            REQUEST__cc_email,
            REQUEST__estimate_deadline,
            lastupdate_user_id: request_lastupdate_user_id,
            web_survey_account,
            onsite_survey_account,
            want_guide_type
        } = request_type <= 3
        ? await this.getRequest(request_natural_id)
        : await this.getRequestOther(request_natural_id)
        const {
            USER__id: USER__id,
            USER__name:REQUEST_LAST_USER__name,
            USER__user_tel:REQUEST_LAST_USER__user_tel
        } = await this.getUser(request_lastupdate_user_id)

        const {
            USER__name:WEB_SURVEY_USER__name,
            USER__user_tel:WEB_SURVEY_USER__user_tel
        } = await this.getUser(web_survey_account)

        const onsiteUserInfo = onsite_survey_account ? await this.getUser(onsite_survey_account) : null
        const ONSITE_SURVEY_USER__name = onsiteUserInfo?onsiteUserInfo.USER__name:""
        const ONSITE_SURVEY_USER__user_tel = onsiteUserInfo?onsiteUserInfo.USER__user_tel:""

        const {
            id :estimate_id,
            estimate_natural_id,
            survey_parking_name,
            survey_parking_prefecture,
            survey_parking_city,
            survey_parking_address,

            survey_parking_address_contract,
            latest_pdf_route_url,
            survey_site_distance_minute,
            survey_site_distance_meter,
            survey_capacity_flag_car,
            survey_capacity_flag_truck,
            survey_capacity_flag_light_truck,
            survey_available_start_date,
            survey_available_end_date,
            survey_capacity_qty,
            survey_capacity_qty_type,
            survey_pay_unit_type_day,
            survey_pay_unit_type_month,
            survey_parking_rent,
            survey_key_money,
            survey_commission_discount_amt,
            survey_commission_discount_rate,
            survey_commission,
            survey_discount_amt,
            survey_adjustment_amt,
            survey_subtotal_amt,
            survey_tax_amt,
            survey_total_amt,
            survey_tax_in_flag,
            
            survey_cost_parking_rent,

            quote_plotting_picture_url,
            quote_plotting_number,
            quote_available_start_date,
            quote_available_end_date,
            quote_capacity_qty,
            quote_subtotal_amt,
            quote_tax_amt,
            quote_total_amt,
            contract_user_id,
            estimate_detail_name,
            estimate_detail_amt,
            survey_cost_parking_rent_payment_type,
            survey_cost_parking_rent_invoice_business_type,
            survey_cost_parking_rent_invoice_registration_number,
            survey_cost_commission_payment_type,
            survey_cost_commission_invoice_business_type,
            survey_cost_commission_invoice_registration_number,
            survey_cost_key_money_payment_type,
            survey_cost_key_money_invoice_business_type,
            survey_cost_key_money_invoice_registration_number
        } = estimateObject

        const {
            USER__name:CONTRACT__name,
            USER__user_tel:CONTRACT__user_tel
        } = await this.getUser(contract_user_id)

        return {
            ESTIMATE__latest_pdf_survey_url:"",
            ESTIMATE__latest_pdf_route_url:"",
            ESTIMATE__latest_pdf_quote_url:"",
            ESTIMATE__latest_pdf_plotting_url:"",
            CUSTOMER_BRANCH__estimate_format_url,
            CUSTOMER_BRANCH__invoice_format_url,
            CUSTOMER_BRANCH__contract_format_url,
            CUSTOMER_BRANCH__send_letter_format_url,
            object_common:this.getObjectCommon(),
            object_user:{
                USER_BRANCH__user_branch_name,
                USER_BRANCH__user_branch_zip_code,
                USER_BRANCH__user_branch_tel,
                USER_BRANCH__user_branch_fax,
                USER__name,
                USER__user_tel,
                USER__email,
                USER__user_cc_email:USER__user_cc_email,
                JOIN_user_branch_user_addr
            },
            object_customer:{
                CUSTOMER_BRANCH__id:CUSTOMER_BRANCH__id,
                CUSTOMER__id:CUSTOMER__id,
                CUSTOMER__customer_name:CUSTOMER__customer_name,
                CUSTOMER_BRANCH__customer_branch_name:CUSTOMER_BRANCH__customer_branch_name,
                CUSTOMER_BRANCH__customer_branch_zip_code:CUSTOMER_BRANCH__customer_branch_zip_code,
                CUSTOMER_BRANCH__customer_branch_tel:CUSTOMER_BRANCH__customer_branch_tel,
                CUSTOMER_BRANCH__customer_branch_fax:CUSTOMER_BRANCH__customer_branch_fax,
                JOIN_customer_branch_user_addr:JOIN_customer_branch_user_addr,
                CUSTOMER_USER__id:CUSTOMER_USER__id,
                CUSTOMER_USER__customer_user_division_name:CUSTOMER_USER__customer_user_division_name,
                CUSTOMER_USER__customer_user_name:CUSTOMER_USER__customer_user_name,
                CUSTOMER_USER__customer_user_email:CUSTOMER_USER__customer_user_email,
                CUSTOMER_USER__customer_user_tel:CUSTOMER_USER__customer_user_tel,
                CUSTOMER_USER__notification_flag:CUSTOMER_USER__notification_flag,
                CUSTOMER_USER__customer_reminder_sms_flag:CUSTOMER_USER__customer_reminder_sms_flag,
                CUSTOMER_USER__customer_reminder_sms_flag_code:CUSTOMER_USER__customer_reminder_sms_flag_code,
                CUSTOMER_BRANCH__customer_branch_cc_email: [
                    ...(CUSTOMER_BRANCH__customer_branch_cc_email?CUSTOMER_BRANCH__customer_branch_cc_email.split(','):[]),
                    ...(REQUEST__cc_email?REQUEST__cc_email.split(','):[])
                ].join(','),
                CUSTOMER_BRANCH__customer_branch_cc_email_quote: [
                    ...(CUSTOMER_BRANCH__customer_branch_cc_email_quote?CUSTOMER_BRANCH__customer_branch_cc_email_quote.split(','):[]),
                    ...(REQUEST__cc_email?REQUEST__cc_email.split(','):[])
                ].join(','),
                CUSTOMER_BRANCH__tax_in_flag
            },
            object_customer_subcontract:{
                CUSTOMER__customer_name:subcontract_CUSTOMER__customer_name||"",
                CUSTOMER_BRANCH__customer_branch_name:subcontract_CUSTOMER_BRANCH__customer_branch_name||"",
                CUSTOMER_BRANCH__customer_branch_zip_code:subcontract_CUSTOMER_BRANCH__customer_branch_zip_code||"",
                CUSTOMER_BRANCH__customer_branch_tel:subcontract_CUSTOMER_BRANCH__customer_branch_tel||"",
                CUSTOMER_BRANCH__customer_branch_fax:subcontract_CUSTOMER_BRANCH__customer_branch_fax||"",
                JOIN_customer_branch_user_addr:subcontract_JOIN_customer_branch_user_addr||"",
                JOIN_subcontract_customer_branch_addr:subcontract_JOIN_customer_branch_user_addr||"",
                CUSTOMER_USER__customer_user_division_name:subcontract_CUSTOMER_USER__customer_user_division_name||"",
                CUSTOMER_USER__customer_user_name:subcontract_CUSTOMER_USER__customer_user_name||"",
                CUSTOMER_USER__customer_user_email:subcontract_CUSTOMER_USER__customer_user_email||"",
                CUSTOMER_USER__customer_user_tel:subcontract_CUSTOMER_USER__customer_user_tel||"",
                CUSTOMER_USER__customer_reminder_sms_flag:subcontract_CUSTOMER_USER__customer_reminder_sms_flag||"",
                CUSTOMER_USER__customer_reminder_sms_flag_code:subcontract_CUSTOMER_USER__customer_reminder_sms_flag_code||"",
                CUSTOMER_BRANCH__customer_branch_cc_email: [
                    ...(subcontract_CUSTOMER_BRANCH__customer_branch_cc_email?subcontract_CUSTOMER_BRANCH__customer_branch_cc_email.split(','):[]),
                    ...(REQUEST__cc_email?REQUEST__cc_email.split(','):[])
                ].join(','),
                CUSTOMER_BRANCH__customer_branch_cc_email_quote: [
                    ...(subcontract_CUSTOMER_BRANCH__customer_branch_cc_email_quote?subcontract_CUSTOMER_BRANCH__customer_branch_cc_email_quote.split(','):[]),
                    ...(REQUEST__cc_email?REQUEST__cc_email.split(','):[])
                ].join(','),
                CUSTOMER_BRANCH__tax_in_flag:subcontract_CUSTOMER_BRANCH__tax_in_flag||""
            },
            object_project:{
                PROJECT__project_natural_id:PROJECT__project_natural_id,
                PROJECT__construction_number:PROJECT__construction_number,
                PROJECT__site_name:PROJECT__site_name,
                JOIN_project_addr:JOIN_project_addr,
                PROJECT__send_destination_type:PROJECT__send_destination_type,
                PROJECT__register_type,
                PROJECT__site_customer_user_tel:PROJECT__site_customer_user_tel,
            },
            object_request:{
                REQUEST__id:REQUEST__id,
                REQUEST__request_type:REQUEST__request_type,
                REQUEST__cc_email:REQUEST__cc_email,
                REQUEST__estimate_deadline:REQUEST__estimate_deadline,
                REQUEST__want_guide_type:want_guide_type
            },
            object_user_request:{
                USER__id:USER__id,
                USER__name:REQUEST_LAST_USER__name,
                USER__user_tel:REQUEST_LAST_USER__user_tel
            },
            object_user_web_survey:{
                USER__name:WEB_SURVEY_USER__name,
                USER__user_tel:WEB_SURVEY_USER__user_tel
            },
            object_user_onsite_survey:{
                USER__name:ONSITE_SURVEY_USER__name,
                USER__user_tel:ONSITE_SURVEY_USER__user_tel
            },
            object_user_contract:{
                USER__name:CONTRACT__name,
                USER__user_tel:CONTRACT__user_tel
            },
            object_estimate:{
                ESTIMATE__id:estimate_id,
                ESTIMATE__estimate_natural_id:estimate_natural_id,
                ESTIMATE__survey_parking_name:survey_parking_name,
                JOIN_parking_addr:FormatCode.decode("cst_prefecture", survey_parking_prefecture) + (survey_parking_city||"") + (survey_parking_address||""),
                ESTIMATE__survey_parking_address_contract: survey_parking_address_contract||"",
                ESTIMATE__latest_pdf_route_url: latest_pdf_route_url||"",
                ESTIMATE__survey_site_distance_minute: survey_site_distance_minute,
                ESTIMATE__survey_site_distance_meter: survey_site_distance_meter,
                ESTIMATE__survey_capacity_flag_car: FormatCode.decode("cst_ab_select", survey_capacity_flag_car)||"",
                ESTIMATE__survey_capacity_flag_truck: FormatCode.decode("cst_ab_select", survey_capacity_flag_truck)||"",
                ESTIMATE__survey_capacity_flag_light_truck: FormatCode.decode("cst_ab_select", survey_capacity_flag_light_truck)||"",
                ESTIMATE__survey_available_start_date: survey_available_start_date,
                ESTIMATE__survey_available_end_date: survey_available_end_date,
                ESTIMATE__survey_capacity_qty: survey_capacity_qty,
                ESTIMATE__survey_capacity_qty_type: FormatCode.decode("cst_survey_capacity_qty_type",survey_capacity_qty_type),
                ESTIMATE__survey_pay_unit_type_day:FormatCode.decode("cst_pay_unit_type_day", survey_pay_unit_type_day)||"",
                ESTIMATE__survey_pay_unit_type_month: FormatCode.decode("cst_pay_unit_type_month", survey_pay_unit_type_month)||"",
                CALC__survey_parking_rent_day: isNaN(parseInt(survey_cost_parking_rent/30))? "": parseInt(survey_cost_parking_rent/30),
                ESTIMATE__survey_parking_rent: survey_parking_rent,
                ESTIMATE__survey_key_money: survey_key_money,
                ESTIMATE__survey_commission_discount_amt: survey_commission_discount_amt,
                ESTIMATE__survey_commission_discount_rate: survey_commission_discount_rate,
                ESTIMATE__survey_commission: survey_commission,
                ESTIMATE__survey_discount_amt: survey_discount_amt,
                ESTIMATE__survey_adjustment_amt: survey_adjustment_amt||"",
                ESTIMATE__survey_subtotal_amt: survey_subtotal_amt,
                ESTIMATE__survey_tax_amt: survey_tax_amt,
                ESTIMATE__survey_total_amt: survey_total_amt,

                ESTIMATE__quote_plotting_picture_url: GoogleDrive.getDownloadUrl(quote_plotting_picture_url),
                ESTIMATE__quote_plotting_number: quote_plotting_number,
                ESTIMATE__quote_available_start_date: quote_available_start_date,
                ESTIMATE__quote_available_end_date: quote_available_end_date,
                ESTIMATE__quote_capacity_qty: quote_capacity_qty,
                ESTIMATE__quote_subtotal_amt: quote_subtotal_amt,
                ESTIMATE__quote_tax_amt: quote_tax_amt,
                ESTIMATE__quote_total_amt: quote_total_amt,

                ESTIMATE__survey_tax_in_flag: FormatCode.decode("cst_tax_in_flag", survey_tax_in_flag),

                ESTIMATE__DETAIL_estimate_detail_name: estimate_detail_name,
                ESTIMATE__DETAIL_estimate_detail_amt: estimate_detail_amt,
                ESTIMATE__survey_cost_parking_rent_payment_type: survey_cost_parking_rent_payment_type,
                ESTIMATE__survey_cost_parking_rent_invoice_business_type: survey_cost_parking_rent_invoice_business_type,
                ESTIMATE__survey_cost_parking_rent_invoice_registration_number: survey_cost_parking_rent_invoice_registration_number,
                ESTIMATE__survey_cost_commission_payment_type: survey_cost_commission_payment_type,
                ESTIMATE__survey_cost_commission_invoice_business_type: survey_cost_commission_invoice_business_type,
                ESTIMATE__survey_cost_commission_invoice_registration_number: survey_cost_commission_invoice_registration_number,
                ESTIMATE__survey_cost_key_money_payment_type: survey_cost_key_money_payment_type,
                ESTIMATE__survey_cost_key_money_invoice_business_type: survey_cost_key_money_invoice_business_type,
                ESTIMATE__survey_cost_key_money_invoice_registration_number: survey_cost_key_money_invoice_registration_number
            },
            debug_msg:""
        }
    }

    static async getInvoiceCommon({
        customer_user_natural_id,
        customer_branch_natural_id,
        subcontract_customer_user_natural_id,
        subcontract_customer_branch_natural_id,
        project_natural_id,
        request_natural_id,
        estimate_natural_id,
        invoice_process_pdf_date,
        invoice_process_pdf_lastupdate,
        invoice_natural_id,
        quote_available_start_date,
        quote_available_end_date,
        request_type,
        payment_deadline,
        invoice_closing_date,
        invoice_amt,
        user_branch_natural_id
    }){
        const {
            USER_BRANCH__user_branch_name,
            USER_BRANCH__user_branch_zip_code,
            USER_BRANCH__user_branch_tel,
            USER_BRANCH__user_branch_fax,
            USER__name,
            USER__user_tel,
            USER__email,
            JOIN_user_branch_user_addr,
        } = await this.getUserParameters(user_branch_natural_id);

        const {
            CUSTOMER__customer_name,
            CUSTOMER_BRANCH__customer_branch_name,
            CUSTOMER_BRANCH__customer_branch_zip_code,

            CUSTOMER_BRANCH__basic_contract_signing_date,
            CUSTOMER_BRANCH__customer_branch_tel,
            CUSTOMER_BRANCH__customer_branch_fax,

            CUSTOMER_BRANCH__tax_in_flag,
            CUSTOMER_BRANCH__customer_branch_cc_email,
            CUSTOMER_BRANCH__customer_branch_cc_email_quote,

            CUSTOMER_BRANCH__invoice_format_url,
            CUSTOMER_BRANCH__contract_format_url,
            CUSTOMER_BRANCH__send_letter_format_url,
            CUSTOMER_BRANCH__inhouse1_format_url,
            CUSTOMER_BRANCH__inhouse2_format_url,
            CUSTOMER_BRANCH__invoice_list_format_url,

            CUSTOMER_BRANCH__invoice_bank_name,
            CUSTOMER_BRANCH__invoice_bank_branch_name,
            CUSTOMER_BRANCH__invoice_bank_account_kana,
            CUSTOMER_BRANCH__invoice_bank_account_type,
            CUSTOMER_BRANCH__invoice_bank_account_number,
            JOIN_customer_branch_user_addr,
        } = await this.getCustomerBranch(customer_branch_natural_id);

        const {
            CUSTOMER__customer_name : subcontract_CUSTOMER__customer_name,
            CUSTOMER_BRANCH__customer_branch_name : subcontract_CUSTOMER_BRANCH__customer_branch_name,
            CUSTOMER_BRANCH__customer_branch_zip_code : subcontract_CUSTOMER_BRANCH__customer_branch_zip_code,
            CUSTOMER_BRANCH__customer_branch_tel : subcontract_CUSTOMER_BRANCH__customer_branch_tel,
            CUSTOMER_BRANCH__customer_branch_fax : subcontract_CUSTOMER_BRANCH__customer_branch_fax,
            CUSTOMER_BRANCH__customer_branch_cc_email : subcontract_CUSTOMER_BRANCH__customer_branch_cc_email,
            CUSTOMER_BRANCH__customer_branch_cc_email_quote : subcontract_CUSTOMER_BRANCH__customer_branch_cc_email_quote,
            JOIN_customer_branch_user_addr : JOIN_subcontract_customer_branch_addr,
        } = await this.getCustomerBranch(subcontract_customer_branch_natural_id,true);
        console.log(customer_user_natural_id)
        const {
            CUSTOMER_USER__customer_user_division_name,
            CUSTOMER_USER__customer_user_name,
            CUSTOMER_USER__customer_user_email,
            CUSTOMER_USER__customer_user_tel,
            CUSTOMER_USER__customer_reminder_sms_flag,
            CUSTOMER_USER__customer_reminder_sms_flag_code
        } = await this.getCustomerUser(customer_user_natural_id);
        console.log(subcontract_customer_user_natural_id)
        const {
            CUSTOMER_USER__customer_user_division_name : subcontract_CUSTOMER_USER__customer_user_division_name,
            CUSTOMER_USER__customer_user_name : subcontract_CUSTOMER_USER__customer_user_name,
            CUSTOMER_USER__customer_user_email : subcontract_CUSTOMER_USER__customer_user_email,
            CUSTOMER_USER__customer_user_tel : subcontract_CUSTOMER_USER__customer_user_tel,
            CUSTOMER_USER__customer_reminder_sms_flag : subcontract_CUSTOMER_USER__customer_reminder_sms_flag,
            CUSTOMER_USER__customer_reminder_sms_flag_code : subcontract_CUSTOMER_USER__customer_reminder_sms_flag_code,
        } = await this.getCustomerUser(subcontract_customer_user_natural_id,true);
        
        const {
            PROJECT__project_natural_id,
            PROJECT__construction_number,
            PROJECT__site_name,
            JOIN_project_addr,
            PROJECT__register_type,
            PROJECT__site_customer_user_tel
        } = await this.getProject(project_natural_id)
        
        const {
            REQUEST__request_type,
            REQUEST__cc_email,
            REQUEST__estimate_deadline
        } = request_type <= 3
        ? await this.getRequest(request_natural_id)
        : await this.getRequestOther(request_natural_id)
        
        const { object_estimate } = await this.getEstimate(estimate_natural_id);
        
        return {
            debug_msg : "",
            CUSTOMER_BRANCH__invoice_format_url,
            CUSTOMER_BRANCH__contract_format_url,
            CUSTOMER_BRANCH__send_letter_format_url,
            CUSTOMER_BRANCH__inhouse1_format_url,
            CUSTOMER_BRANCH__inhouse2_format_url,
            CUSTOMER_BRANCH__invoice_list_format_url,
            ESTIMATE__latest_pdf_quote_url : object_estimate.ESTIMATE__latest_pdf_quote_url,
            ESTIMATE__latest_pdf_survey_url:"",
            ESTIMATE__latest_pdf_route_url:"",
            ESTIMATE__latest_pdf_plotting_url:"",
            object_common:this.getObjectCommon(),
            object_user : {
                USER_BRANCH__user_branch_name,
                USER_BRANCH__user_branch_zip_code,
                USER_BRANCH__user_branch_tel,
                USER_BRANCH__user_branch_fax,
                USER__name,
                USER__user_tel,
                USER__email,
                JOIN_user_branch_user_addr,
            },
            object_customer : {
                CUSTOMER__customer_name,
                CUSTOMER_BRANCH__customer_branch_name,
                CUSTOMER_BRANCH__customer_branch_zip_code,

                CUSTOMER_BRANCH__basic_contract_signing_date,
                CUSTOMER_BRANCH__customer_branch_tel,
                CUSTOMER_BRANCH__customer_branch_fax,

                CUSTOMER_USER__customer_user_division_name,
                CUSTOMER_USER__customer_user_name,
                CUSTOMER_USER__customer_user_email,
                CUSTOMER_USER__customer_user_tel,
                CUSTOMER_USER__customer_reminder_sms_flag,
                JOIN_customer_branch_user_addr,
                CUSTOMER_BRANCH__tax_in_flag,
                CUSTOMER_BRANCH__customer_branch_cc_email,
                CUSTOMER_BRANCH__customer_branch_cc_email_quote,
                CUSTOMER_USER__customer_reminder_sms_flag_code
            },
            object_customer_subcontract : {
                CUSTOMER__customer_name : subcontract_CUSTOMER__customer_name,
                CUSTOMER_BRANCH__customer_branch_name : subcontract_CUSTOMER_BRANCH__customer_branch_name,
                CUSTOMER_BRANCH__customer_branch_zip_code : subcontract_CUSTOMER_BRANCH__customer_branch_zip_code,

                CUSTOMER_BRANCH__customer_branch_tel : subcontract_CUSTOMER_BRANCH__customer_branch_tel,
                CUSTOMER_BRANCH__customer_branch_fax : subcontract_CUSTOMER_BRANCH__customer_branch_fax,

                CUSTOMER_USER__customer_user_division_name : subcontract_CUSTOMER_USER__customer_user_division_name,
                CUSTOMER_USER__customer_user_name : subcontract_CUSTOMER_USER__customer_user_name,
                CUSTOMER_USER__customer_user_email : subcontract_CUSTOMER_USER__customer_user_email,
                CUSTOMER_USER__customer_user_tel : subcontract_CUSTOMER_USER__customer_user_tel,
                CUSTOMER_USER__customer_reminder_sms_flag : subcontract_CUSTOMER_USER__customer_reminder_sms_flag,
                JOIN_subcontract_customer_branch_addr : JOIN_subcontract_customer_branch_addr,
                CUSTOMER_BRANCH__customer_branch_cc_email : subcontract_CUSTOMER_BRANCH__customer_branch_cc_email,
                CUSTOMER_BRANCH__customer_branch_cc_email_quote : subcontract_CUSTOMER_BRANCH__customer_branch_cc_email_quote,
                CUSTOMER_USER__customer_reminder_sms_flag_code : subcontract_CUSTOMER_USER__customer_reminder_sms_flag_code,
            },
            object_project : {
                PROJECT__project_natural_id,
                PROJECT__construction_number,
                PROJECT__site_name,
                JOIN_project_addr,
                PROJECT__register_type,
                PROJECT__site_customer_user_tel: PROJECT__site_customer_user_tel
            },
            object_request : {
                REQUEST__request_type,
                REQUEST__cc_email,
                REQUEST__estimate_deadline
            },
            object_user_request:{
                USER__name:USER__name,
                USER__user_tel:USER__user_tel
            },
            object_user_web_survey:{
                USER__name:USER__name,
                USER__user_tel:USER__user_tel
            },
            object_user_onsite_survey:{
                USER__name:USER__name,
                USER__user_tel:USER__user_tel
            },
            object_invoice : {
                INVOICE__invoice_natural_id : invoice_natural_id,
                INVOICE__invoice_closing_date : invoice_closing_date,
                INVOICE__invoice_amt : invoice_amt,
                INVOICE__payment_deadline : payment_deadline,
                CUSTOMER_BRANCH__invoice_bank_name,
                CUSTOMER_BRANCH__invoice_bank_branch_name,
                CUSTOMER_BRANCH__invoice_bank_account_kana,
                CUSTOMER_BRANCH__invoice_bank_account_type,
                CUSTOMER_BRANCH__invoice_bank_account_number,
            },
            object_estimate : object_estimate,
        }
    }
    static async getContractCommon({
        customer_user_natural_id,
        customer_branch_natural_id,
        subcontract_customer_user_natural_id,
        subcontract_customer_branch_natural_id,
        project_natural_id,
        request_natural_id,
        estimate_natural_id,
        invoice_process_pdf_date,
        invoice_process_pdf_lastupdate,
        invoice_natural_id,
        quote_available_start_date,
        quote_available_end_date,
        request_type,
        payment_deadline,
        invoice_closing_date,
        invoice_amt,
    }){
        const {
            USER_BRANCH__user_branch_name,
            USER_BRANCH__user_branch_zip_code,
            USER_BRANCH__user_branch_tel,
            USER_BRANCH__user_branch_fax,
            USER__name,
            USER__user_tel,
            USER__email,
            JOIN_user_branch_user_addr,
        } = await this.getUserParameters();

        const {
            CUSTOMER__customer_name,
            CUSTOMER_BRANCH__customer_branch_name,
            CUSTOMER_BRANCH__customer_branch_zip_code,

            CUSTOMER_BRANCH__basic_contract_signing_date,
            CUSTOMER_BRANCH__customer_branch_tel,
            CUSTOMER_BRANCH__customer_branch_fax,

            CUSTOMER_BRANCH__tax_in_flag,
            CUSTOMER_BRANCH__customer_branch_cc_email,
            CUSTOMER_BRANCH__customer_branch_cc_email_quote,

            CUSTOMER_BRANCH__invoice_format_url,
            CUSTOMER_BRANCH__contract_format_url,
            CUSTOMER_BRANCH__send_letter_format_url,
            CUSTOMER_BRANCH__inhouse1_format_url,
            CUSTOMER_BRANCH__inhouse2_format_url,
            CUSTOMER_BRANCH__invoice_list_format_url,

            CUSTOMER_BRANCH__invoice_bank_name,
            CUSTOMER_BRANCH__invoice_bank_branch_name,
            CUSTOMER_BRANCH__invoice_bank_account_kana,
            CUSTOMER_BRANCH__invoice_bank_account_type,
            CUSTOMER_BRANCH__invoice_bank_account_number,
            JOIN_customer_branch_user_addr,
        } = await this.getCustomerBranch(customer_branch_natural_id);

        const {
            CUSTOMER__customer_name : subcontract_CUSTOMER__customer_name,
            CUSTOMER_BRANCH__customer_branch_name : subcontract_CUSTOMER_BRANCH__customer_branch_name,
            CUSTOMER_BRANCH__customer_branch_zip_code : subcontract_CUSTOMER_BRANCH__customer_branch_zip_code,
            CUSTOMER_BRANCH__customer_branch_tel : subcontract_CUSTOMER_BRANCH__customer_branch_tel,
            CUSTOMER_BRANCH__customer_branch_fax : subcontract_CUSTOMER_BRANCH__customer_branch_fax,
            CUSTOMER_BRANCH__customer_branch_cc_email : subcontract_CUSTOMER_BRANCH__customer_branch_cc_email,
            CUSTOMER_BRANCH__customer_branch_cc_email_quote : subcontract_CUSTOMER_BRANCH__customer_branch_cc_email_quote,
            JOIN_subcontract_customer_branch_addr : JOIN_subcontract_customer_branch_addr,
        } = await this.getCustomerBranch(subcontract_customer_branch_natural_id,true);
        
        const {
            CUSTOMER_USER__customer_user_division_name,
            CUSTOMER_USER__customer_user_name,
            CUSTOMER_USER__customer_user_email,
            CUSTOMER_USER__customer_user_tel,
            CUSTOMER_USER__customer_reminder_sms_flag,
        } = await this.getCustomerUser(customer_user_natural_id);

        const {
            CUSTOMER_USER__customer_user_division_name : subcontract_CUSTOMER_USER__customer_user_division_name,
            CUSTOMER_USER__customer_user_name : subcontract_CUSTOMER_USER__customer_user_name,
            CUSTOMER_USER__customer_user_email : subcontract_CUSTOMER_USER__customer_user_email,
            CUSTOMER_USER__customer_user_tel : subcontract_CUSTOMER_USER__customer_user_tel,
            CUSTOMER_USER__customer_reminder_sms_flag : subcontract_CUSTOMER_USER__customer_reminder_sms_flag,
        } = await this.getCustomerUser(subcontract_customer_user_natural_id,true);
        
        const {
            PROJECT__project_natural_id,
            PROJECT__construction_number,
            PROJECT__site_name,
            JOIN_project_addr,
            PROJECT__register_type
        } = await this.getProject(project_natural_id)
        
        const {
            REQUEST__request_type,
            REQUEST__cc_email,
            REQUEST__estimate_deadline
        } = request_type <= 3
        ? await this.getRequest(request_natural_id)
        : await this.getRequestOther(request_natural_id)
        
        const { object_estimate } = await this.getEstimate(estimate_natural_id,true);
        
        return {
            debug_msg : "",
            CUSTOMER_BRANCH__invoice_format_url,
            CUSTOMER_BRANCH__contract_format_url,
            CUSTOMER_BRANCH__send_letter_format_url,
            CUSTOMER_BRANCH__inhouse1_format_url,
            CUSTOMER_BRANCH__inhouse2_format_url,
            CUSTOMER_BRANCH__invoice_list_format_url,
            ESTIMATE__latest_pdf_quote_url : object_estimate.ESTIMATE__latest_pdf_quote_url,
            object_common:this.getObjectCommon(),
            object_user : {
                USER_BRANCH__user_branch_name,
                USER_BRANCH__user_branch_zip_code,
                USER_BRANCH__user_branch_tel,
                USER_BRANCH__user_branch_fax,
                USER__name,
                USER__user_tel,
                USER__email,
                JOIN_user_branch_user_addr,
            },
            object_customer : {
                CUSTOMER__customer_name,
                CUSTOMER_BRANCH__customer_branch_name,
                CUSTOMER_BRANCH__customer_branch_zip_code,

                CUSTOMER_BRANCH__basic_contract_signing_date,
                CUSTOMER_BRANCH__customer_branch_tel,
                CUSTOMER_BRANCH__customer_branch_fax,

                CUSTOMER_USER__customer_user_division_name,
                CUSTOMER_USER__customer_user_name,
                CUSTOMER_USER__customer_user_email,
                CUSTOMER_USER__customer_user_tel,
                CUSTOMER_USER__customer_reminder_sms_flag,
                JOIN_customer_branch_user_addr,
                CUSTOMER_BRANCH__tax_in_flag,
                CUSTOMER_BRANCH__customer_branch_cc_email,
                CUSTOMER_BRANCH__customer_branch_cc_email_quote
            },
            object_customer_subcontract : {
                CUSTOMER__customer_name : subcontract_CUSTOMER__customer_name,
                CUSTOMER_BRANCH__customer_branch_name : subcontract_CUSTOMER_BRANCH__customer_branch_name,
                CUSTOMER_BRANCH__customer_branch_zip_code : subcontract_CUSTOMER_BRANCH__customer_branch_zip_code,

                CUSTOMER_BRANCH__customer_branch_tel : subcontract_CUSTOMER_BRANCH__customer_branch_tel,
                CUSTOMER_BRANCH__customer_branch_fax : subcontract_CUSTOMER_BRANCH__customer_branch_fax,

                CUSTOMER_USER__customer_user_division_name : subcontract_CUSTOMER_USER__customer_user_division_name,
                CUSTOMER_USER__customer_user_name : subcontract_CUSTOMER_USER__customer_user_name,
                CUSTOMER_USER__customer_user_email : subcontract_CUSTOMER_USER__customer_user_email,
                CUSTOMER_USER__customer_user_tel : subcontract_CUSTOMER_USER__customer_user_tel,
                CUSTOMER_USER__customer_reminder_sms_flag : subcontract_CUSTOMER_USER__customer_reminder_sms_flag,
                JOIN_subcontract_customer_branch_addr : JOIN_subcontract_customer_branch_addr || "" ,
                CUSTOMER_BRANCH__customer_branch_cc_email : subcontract_CUSTOMER_BRANCH__customer_branch_cc_email,
                CUSTOMER_BRANCH__customer_branch_cc_email_quote : subcontract_CUSTOMER_BRANCH__customer_branch_cc_email_quote
            },
            object_project : {
                INVOICE__project_natural_id : PROJECT__project_natural_id,
                PROJECT__construction_number,
                PROJECT__site_name,
                JOIN_project_addr,
                PROJECT__register_type,
            },
            object_request : {
                REQUEST__request_type,
                REQUEST__cc_email,
                REQUEST__estimate_deadline
            },
            object_invoice : {
                INVOICE__invoice_natural_id : invoice_natural_id,
                INVOICE__invoice_closing_date : invoice_closing_date,
                INVOICE__invoice_amt : invoice_amt,
                INVOICE__payment_deadline : payment_deadline,
                CUSTOMER_BRANCH__invoice_bank_name,
                CUSTOMER_BRANCH__invoice_bank_branch_name,
                CUSTOMER_BRANCH__invoice_bank_account_kana,
                CUSTOMER_BRANCH__invoice_bank_account_type,
                CUSTOMER_BRANCH__invoice_bank_account_number,
            },
            object_estimate : object_estimate
        }
    }
    static getNaturalId(params){
        return new Promise((resolve, reject)=>{
                const naturalIdUrl = '/api/create/natural_id'
                Request.post(naturalIdUrl, params, res=>{
//                        console.log(res)
                        resolve(res.Data)
                    }, err=>{
                        console.log('Error!', err)
                        reject(undefined)
                },()=>{},true,false)
            })
    }
    static async getRequiredData(url, data){
        const {values} = data
        const requiredData = await new Promise((resolve)=>{
            Request.post(url + '?check=true', {}, res => {
                if (res.Code>=800) {
                    resolve(res.Data)
                }else {
                    resolve({})
                }
            }, (err)=>{
                resolve({})
            }, ()=>{}, true, false);
        })
        const errors = this.getErrorsFromRequiredData(values, requiredData)
        return {
            values,
            errors,
            requiredData
        }
    }
    static getErrorsFromRequiredData(values,requiredData){
        return Object.keys(requiredData).reduce((acc, key)=>{
            if((values[key] === undefined || values[key] === null || values[key] === "") && requiredData[key]){
                acc[key] = [GetMessage(2024)]
            }
            return acc
        },{})
    }
}